type CanalPortal = "whatsapp" | "email";

type ApiError = { error?: string };

async function request<T>(path: string, options?: RequestInit): Promise<T> {
  const response = await fetch(path, {
    ...options,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      ...(options?.headers || {}),
    },
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error((data as ApiError).error || "Não foi possível concluir a operação.");
  return data as T;
}

export type DestinatarioPortal = {
  id: number;
  nome: string;
  emitenteId: number;
  emitenteNome: string;
};

export type ProdutoPublico = {
  id: number;
  cod: string;
  descricao: string | null;
  fotoPortalUrl: string | null;
  disponibilidade: "disponivel" | "indisponivel";
};

export type ProdutoPortal = ProdutoPublico & {
  precoOriginal: number;
  precoFinal: number;
};

export type PedidoPortal = {
  numero: number;
  status: string;
  criadoEm: string;
};

export type PedidoPortalDetalhe = PedidoPortal & {
  valor: number;
  itens: Array<{
    cod: string;
    descricao: string;
    quantidade: number;
    valorUnitario: number;
    valorTotal: number;
  }>;
};

export const portalClienteApi = {
  solicitarCodigo(canal: CanalPortal, contato: string) {
    return request<{ success: true }>("/api/portal-cliente/acesso/solicitar", {
      method: "POST",
      body: JSON.stringify({ canal, contato }),
    });
  },
  validarCodigo(canal: CanalPortal, contato: string, codigo: string) {
    return request<{ destinatarios: DestinatarioPortal[] }>("/api/portal-cliente/acesso/validar", {
      method: "POST",
      body: JSON.stringify({ canal, contato, codigo }),
    });
  },
  sessao() {
    return request<{ destinatarios: DestinatarioPortal[] }>("/api/portal-cliente/sessao");
  },
  selecionarDestinatario(destinatarioId: number) {
    return request<{ destinatario: DestinatarioPortal }>("/api/portal-cliente/destinatario/selecionar", {
      method: "POST",
      body: JSON.stringify({ destinatarioId }),
    });
  },
  catalogoPublico(emitente: string) {
    return request<{ produtos: ProdutoPublico[] }>(`/api/portal-cliente/catalogo-publico/${encodeURIComponent(emitente)}`);
  },
  catalogo(destinatarioId: number) {
    return request<{ produtos: ProdutoPortal[] }>(`/api/portal-cliente/catalogo?destinatarioId=${destinatarioId}`);
  },
  pedidos(destinatarioId: number) {
    return request<{ pedidos: PedidoPortal[] }>(`/api/portal-cliente/pedidos?destinatarioId=${destinatarioId}`);
  },
  detalhePedido(destinatarioId: number, pedidoId: number) {
    return request<{ pedido: PedidoPortalDetalhe }>(`/api/portal-cliente/pedidos/${pedidoId}?destinatarioId=${destinatarioId}`);
  },
  enviarOrcamento(destinatarioId: number, items: Array<{ productId: number; quantidade: number }>) {
    return request<{ id: number; numero: number }>("/api/portal-cliente/orcamentos", {
      method: "POST",
      body: JSON.stringify({ destinatarioId, items }),
    });
  },
};
